import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import SimpleDataTable from "lib/components/common/simple-data-table";
import usePackages from "lib/hooks/usePackages";
import PackageDetails from "./package-details";
import LoadingBox from "lib/components/common/loading-box";
import { PACKAGES_COLUMNS } from "lib/constants/table-columns";

const Packages = () => {
  const [selectedPackage, setSelectedPackage] = useState<Package>(null);
  const {
    packages,
    getPackages,
    loading,
    error,
    updatePackage,
    addPackage,
    deletePackage,
    resetError,
  } = usePackages();

  useEffect(() => {
    getPackages();
  }, []);

  const handleAddPackage = async (packageData: Package) => {
    addPackage(packageData, (newPackage) => {
      setSelectedPackage(null);
      getPackages();
    });
  };

  const handleUpdatePackage = (packageData: Package) => {
    updatePackage(packageData, (updatedPackage) => {
      setSelectedPackage(null);
      getPackages();
    });
  };

  const handleDeletePackage = (packageId: string) => {
    if (window.confirm("Are you sure you want to delete this package?")) {
      deletePackage(packageId, () => {
        setSelectedPackage(null);
        getPackages();
      });
    }
  };

  const handlePackageSelection = (packageData?: Package) => {
    if (packageData) {
      setSelectedPackage(packageData);
    } else {
      setSelectedPackage({} as Package);
    }
  };

  if (loading) return <LoadingBox message="Processing your request" />;

  if (selectedPackage) {
    return (
      <PackageDetails
        error={error}
        isLoading={loading}
        updatePackage={handleUpdatePackage}
        addPackage={handleAddPackage}
        deletePackage={handleDeletePackage}
        packageData={selectedPackage}
        onCancelClick={() => {
          resetError();
          setSelectedPackage(null);
        }}
      />
    );
  }

  return (
    <>
      <SimpleDataTable
        isLoading={loading}
        error={error}
        columns={PACKAGES_COLUMNS}
        data={packages}
        title="Packages"
        action={
          <Button onClick={() => handlePackageSelection()}>Add Package</Button>
        }
        onRowClick={handlePackageSelection}
      />
    </>
  );
};

export default Packages;